import { api } from '../../api'
import type { RevenueAnalyticsDTO, RestaurantRevenueDTO } from '@/types/admin'

/**
 * Get revenue analytics for a specific time period
 */
export async function getRevenueAnalytics(params: {
  startDate: string // ISO format: YYYY-MM-DD
  endDate: string // ISO format: YYYY-MM-DD
  groupBy?: 'DAY' | 'WEEK' | 'MONTH'
}): Promise<RevenueAnalyticsDTO> {
  const response = await api.get<RevenueAnalyticsDTO>('/api/admin/analytics/revenue', { params })
  return response.data
}

/**
 * Get revenue breakdown by restaurant
 */
export async function getRevenueByRestaurant(): Promise<RestaurantRevenueDTO[]> {
  const response = await api.get<RestaurantRevenueDTO[]>('/api/admin/analytics/revenue-by-restaurant')
  return response.data
}
